// ---------------------------------------------------------------------------
// 発行を取消して下書きに戻した帳票（番号はそのまま）の状態チップ（#273・#276・#278、docs/99 §3・§9）。
//   見積書・請求書・領収書・{deliveryNote}・{acceptance}・{order}・{paymentNotice}の見出しのチップと一覧の状態が同じ言葉。
//   #273・#276 で「取消済」→「発行取消」、#278（10/31 射場さん ★2）で一覧と同じ「下書き」に戻した
//   （「発行取消」は取り消された帳票に読めた）。番号のある下書きだと分かるのは、乗せたときの説明と見出しの「？」の1行と、
//   発行の確認の窓の1行（reissue）。ほかのファイルを import しない（estimatePc・estimate・order・paymentNotice・deliveryNote が読む）
// ---------------------------------------------------------------------------

export const UNISSUED_MSG = {
  chip: "下書き",
  /** {no} は表示番号（訂正版は枝番つき） */
  title: "{no} の発行を取消した下書きです。修正して再発行できます",
  /** 発行の確認の窓の本文の1行（番号のある下書きのときだけ。#278） */
  reissue: "{no} は一度発行して取消した番号です。同じ番号で再発行します。",
} as const;

/** チップの title と見出しの「？」の1行（句点なし）。no は表示番号 */
export const unissuedTitle = (no: string): string => UNISSUED_MSG.title.replace("{no}", no);

/** 発行の確認の窓の1行（番号のある下書きのときだけ。#278）。no は表示番号 */
export const unissuedReissue = (no: string): string => UNISSUED_MSG.reissue.replace("{no}", no);
